import { fg } from '@dev-agents/feature-gates';
import { githubOauthRedirectPath } from '@dev-agents/route-paths';
import { useSyncExternalStore } from 'react';

import { appHistory } from '../utils/app-history';
import { DEVAI_BASE_PATH, ROVO_DEV_BASE_PATH } from '../utils/constants';

import { AppRouteComponentWithAggHeaders } from './AppRouteComponentWithAggHeaders';
import { StandaloneGithubOauthRedirectPage } from './github-oauth-redirect/standalone-page';

const standalonePaths = new Set(
	[ROVO_DEV_BASE_PATH, DEVAI_BASE_PATH].map((basePath) => `${basePath}${githubOauthRedirectPath}`),
);
const getPathname = () => appHistory.location.pathname;

// Select the callback before initializing Rovo Dev sessions, permissions and entitlements.
// Observe the product router's history without introducing a nested router store.
export const AppRouter = () => {
	const pathname = useSyncExternalStore(appHistory.listen, getPathname);

	if (
		standalonePaths.has(pathname.replace(/\/$/, '')) &&
		fg('dev_agents_standalone_github_oauth_redirect')
	) {
		return <StandaloneGithubOauthRedirectPage />;
	}

	return <AppRouteComponentWithAggHeaders />;
};
